import { render, staticRenderFns } from "./SelectSmall.vue?vue&type=template&id=5b84ac98&scoped=true"
import script from "./SelectSmall.vue?vue&type=script&lang=js"
export * from "./SelectSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b84ac98",
  null
  
)

export default component.exports